import Vue from 'vue';
import VueRouter from 'vue-router';

import store from 'src/store';
import routes from './routes';
import { wait } from '../util/helper';

Vue.use(VueRouter);

const router = new VueRouter({
	scrollBehavior: async (to, from, savedPosition) => {
		await wait(500);
		return savedPosition || { x: 0, y: 0 };
	},

	routes,

	/*
		 * Leave these as is and change from quasar.conf.js instead!
		 * quasar.conf.js -> build -> vueRouterMode
		 * quasar.conf.js -> build -> publicPath
		 */
	mode: process.env.VUE_ROUTER_MODE,
	base: process.env.VUE_ROUTER_BASE,
});

router.beforeEach((to, from, next) => {
	if (
		to.path !== '/browser'
		&& (
			!window.Proxy
			|| !Array.prototype.flat
		)
		&& !sessionStorage.getItem('ignore-browser-error')
	) {
		return next('/browser');
	}

	if (to.matched.some(route => route.meta.checkStore)) {
		const forward = to.matched
			.map((route) => {
				if (!route.meta.checkStore) return true;
				if (route.meta.checkStore instanceof Array) {
					for (const checkStore of route.meta.checkStore) {
						const check = checkStore(store);
						if (check !== true) return check;
					}
					return true;
				}
				return route.meta.checkStore(store);
			})
			.filter(route => typeof route === 'string');

		return next(forward[0] && { path: forward[0], replace: true });
	}

	next();
});

export default router;

export function checkGetter(getter, haveToBe, forwardIfNot) {
	return store => store.getters[getter] === haveToBe || forwardIfNot;
}
